const appendURLSearchParams = (baseUrl, searchParams) => {
    const searchParamsStr = searchParams.toString();
    return searchParamsStr ? `${baseUrl}?${searchParamsStr}` : baseUrl;
};

// Relative Universal Login localised url for brands support
const buildUniversalUrl = (operation, queryParams) => {
    const basePath = (window.location.pathname.match(/^\/[a-z]{2}-[a-z]{2}/) || [
        '',
    ])[0];

    const redirectTo = window.location.pathname + window.location.search;

    const newQueryParams = new URLSearchParams({
        ...queryParams,
        redirectTo,
    });
    return appendURLSearchParams(`${basePath}/${operation}`, newQueryParams);
};

const getRegistrationUrl = (marketingPreferencePageType, marketingPreferencePageName) =>
    buildUniversalUrl('signup', {
        enable_registration: true,
        ...(marketingPreferencePageType && {referrer_page_location: marketingPreferencePageType}),
        ...(marketingPreferencePageName && {referrer_page_name: marketingPreferencePageName})
    });

const getLoginUrl = (marketingPreferencePageType, marketingPreferencePageName) => buildUniversalUrl('login', {
    enable_login: true,
    ...(marketingPreferencePageType && {referrer_page_location: marketingPreferencePageType}),
    ...(marketingPreferencePageName && {referrer_page_name: marketingPreferencePageName})
});

export {getRegistrationUrl, getLoginUrl};
